import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ObservationComponent } from './observation.component';
import { DatetimepickerModule } from '@headpower/components';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ObservationsService } from './observations.service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';

import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { BlahModule } from '@headpower/blah-ng';



@NgModule({
  declarations: [
    ObservationComponent
  ],
  exports: [
    ObservationComponent
  ],
  imports: [
    CommonModule,
    DatetimepickerModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,
    BlahModule
  ],
  providers: [
    ObservationsService
  ]
})
export class ObservationModule { }
